export default __webpack_public_path__ + "static/media/betano-logo.128107f4.png";